import Storage from '@/utils/storage'
import { make } from 'vuex-pathify'
import VueApp from '@/main'
import { appDefaultName } from '@/config'

let locale = Storage.get('LOCALE_DEFAULT', 'en') || 'en'
const theme = Storage.get('THEME_DEFAULT', 'light') || 'light'

if (!['en', 'vi'].includes(locale)) {
  locale = 'en'
}

const state = {
  name: appDefaultName,
  loading: false,
  drawer: null,
  locale,
  settings: false,
  theme
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),

  setLocale: ({ commit }, { value }) => {
    if (!['en', 'vi'].includes(value)) {
      value = 'en'
    }

    const message = VueApp.$i18n.getLocaleMessage(value).confirm_change_language || 'The browser will be reload to change language.'

    if (confirm(message)) {
      commit('SET_LOCALE', value)
      Storage.set('LOCALE_DEFAULT', value)
      window.location.reload()
    }
  },

  setTheme: ({ commit }, { value }) => {
    if (!['light', 'dark'].includes(value)) {
      value = 'light'
    }
    VueApp.$vuetify.theme.dark = value === 'dark'
    if (value === 'dark') {
      window.document.body.classList.add('body-dark')
      window.document.body.classList.remove('body-light')
    } else {
      window.document.body.classList.remove('body-dark')
      window.document.body.classList.add('body-light')
    }
    Storage.set('THEME_DEFAULT', value)
    commit('SET_THEME', value)
  }
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
